(function () {
  'use strict';

  function enhanceProductDesc(root) {
    var desc = root.querySelector('.sap-product__desc');
    var leadTarget = root.querySelector('[data-product-lead]');
    var detailsWrap = root.querySelector('[data-product-details]');
    if (!desc || desc.getAttribute('data-desc-enhanced') === '1') return;

    var headings = desc.querySelectorAll(':scope > h2');
    if (!headings.length) return;

    desc.setAttribute('data-desc-enhanced', '1');
    if (detailsWrap) detailsWrap.classList.add('sap-product__details--ready');

    var stack = document.createElement('div');
    stack.className = 'sap-pdp__detail-stack';

    headings.forEach(function (heading, index) {
      var isOverview = index === 0;
      var isRelated = /related plans/i.test(heading.textContent || '');

      var body = document.createElement('div');
      body.className = 'sap-pdp__detail-body';

      var node = heading.nextElementSibling;
      while (node && node.tagName !== 'H2') {
        var next = node.nextElementSibling;
        body.appendChild(node);
        node = next;
      }

      if (isOverview && leadTarget) {
        var leadText = body.textContent.trim();
        if (leadText) {
          leadTarget.textContent = leadText;
          leadTarget.hidden = false;
          leadTarget.classList.add('sap-product__lead--visible');
        }
        return;
      }

      var item = document.createElement('article');
      item.className = 'sap-pdp__detail-card';
      if (isRelated) item.classList.add('sap-pdp__detail-card--related');

      var title = document.createElement('h3');
      title.textContent = heading.textContent;
      item.appendChild(title);
      item.appendChild(body);
      stack.appendChild(item);
    });

    desc.textContent = '';
    desc.appendChild(stack);
  }

  function bindQty() {
    document.querySelectorAll('[data-pdp-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('input[name="quantity"]');
      if (!input) return;
      var minus = wrap.querySelector('[data-qty-minus]');
      var plus = wrap.querySelector('[data-qty-plus]');
      function clamp() {
        var n = parseInt(input.value, 10);
        if (!n || n < 1) n = 1;
        if (n > 20) n = 20;
        input.value = String(n);
      }
      minus && minus.addEventListener('click', function () {
        input.value = String(Math.max(1, (parseInt(input.value, 10) || 1) - 1));
      });
      plus && plus.addEventListener('click', function () {
        input.value = String(Math.min(20, (parseInt(input.value, 10) || 1) + 1));
      });
      input.addEventListener('change', clamp);
    });
  }

  function initProductPage() {
    document.querySelectorAll('.sap-product--premium').forEach(enhanceProductDesc);
    bindQty();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductPage);
  } else {
    initProductPage();
  }
})();
